import React, {useEffect, useRef, useState} from 'react';
import MaterialTable from 'material-table';
import Permissions from "../../../../auth/permissions";
import {PriceFormModal} from "./components/PriceFormModal";
import {BasePriceURL} from "../../../../urls";
import Paper from "@material-ui/core/Paper";
import {TableToolbar} from "../../../../components/TableToolbar";
import "../../../../assets/scss/Static.scss";
import {
    material_table_localization,
    material_table_options,
    material_table_style
} from "../../../../components/Material_conf";
import {getLabel} from "../../../../localization/MainLocalization";
import Chip from "@material-ui/core/Chip";
import {Hide} from "../../../../components/Hide";
import {httpRequestWithAuth, instance} from "../../../../auth/axios_instance";
import {RetrievePriceList} from "../price_list/price_list_apis";
import {permissions_data} from "../../../../auth/permission_data";
import {sub_directory} from "../../../../App";


export const Prices = props => {
    const state = props.history.location.state || {};

    useEffect(() => {
        if (!(state.service && state.pricelist)) {
            props.history.push(`${sub_directory}services`);
        }
    }, []);


    let is_rent = false;
    const tableRef = useRef();

    const [columns, setColumns] = useState([
        // {title: get_label("pages.prices.price_id"), field: 'id'},
        // {title: get_label("pages.packages.package_id"), field: 'package'},
        {title: getLabel("name"), field: 'name'},
        {title: getLabel("price"), field: 'price'},
        {
            title: getLabel("duration"), field: 'duration',
            render: rowData => <label>{rowData.duration} <label className="mr-1 ml-1">Days</label></label>
        },
        {title: getLabel("sessions"), field: 'sessions'},
        {title: getLabel("pages.prices.freeze_days"), field: 'freeze_days'},
        {
            title: getLabel('status'),
            render: rowData => {
                return (
                    <Chip color={rowData.is_active ? "primary" : "default"} label={rowData.is_active_view}/>)
            },
        },
    ]);
    const [form_open, setFormOpen] = useState(false)
    const [new_price, setNewPrice] = useState({})
    const [search, setSearch] = useState("")

    useEffect(() => {
        const fetchData = async () => {
            let response = await RetrievePriceList(state.pricelist);
            if (response.status) {
                is_rent = response.data.is_rent
            }
        }

        fetchData();
    }, [])


    const reloadData = async () => {
        tableRef.current && tableRef.current.onChangePage(tableRef.current, 0);
        tableRef.current && tableRef.current.onQueryChange();
    };

    const handleModalClose = async () => {
        await reloadData();
        await setFormOpen(false)
        await setNewPrice({})
    };


    const handleModalOpen = async data => {
        if (data !== "new") {
            await setNewPrice(data)
        }
        await setFormOpen(true)
    };


    const handleSearchField = (name, newValue) => {
        setSearch("")

        if (newValue.length >= 5 || newValue === '') {
            reloadData();
        }
    };


    return (
        <>
            <Hide hide={!form_open}>
                <PriceFormModal
                    open={form_open}
                    handleModalClose={handleModalClose}
                    default_data={{...new_price, price_list: state.pricelist}}
                    is_rent={is_rent}
                />
            </Hide>


            <Paper>
                <TableToolbar
                    searchFieldName='search'
                    searchValue={search}
                    onSearchChangeHandle={handleSearchField}
                    searchAction={reloadData}
                    match={props.match}
                    breadcrumDetails={state}
                    actions={
                        [
                            {
                                hide: !Permissions.checkAllPermissions([permissions_data.price.add]),
                                onClick: () => handleModalOpen('new'),
                                label: "pages.prices.add_price"
                            },
                        ]
                    }
                />

                <MaterialTable
                    tableRef={tableRef}
                    columns={columns}
                    data={query =>
                        new Promise((resolve, reject) => {
                            let url = BasePriceURL;
                            url += '?page=' + (query.page + 1);

                            url += '&price_list=' + state.pricelist;

                            if (search !== '') {
                                url += '&search=' + search;
                            }

                            instance.get(url)
                                .then(result => {
                                    resolve({
                                        data: result.data.results,
                                        page: result.data.page - 1,
                                        totalCount: result.data.total,
                                    })
                                })
                        })
                    }
                    editable={
                        Permissions.checkPermission(permissions_data.price.delete) && {
                            onRowDelete: async PriceData => {
                                await httpRequestWithAuth(`${BasePriceURL}${PriceData.id}/`, "DELETE");
                                await reloadData();
                            }
                        }}


                    actions={[
                        {
                            icon: 'edit',
                            hidden: !Permissions.checkAllPermissions([permissions_data.price.change]),
                            tooltip: getLabel("pages.prices.edit_price"),
                            onClick: (event, rowData) => handleModalOpen(rowData)
                        },


                    ]}


                    {...material_table_style}
                    {...material_table_options()}
                    {...material_table_localization()}
                />
            </Paper>
        </>
    );
}

